import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { BetaTag } from '@/components';
import { RootStore } from '@/models';
import styles from './index.less';

interface Props extends Partial<Pick<RootStore, 'meeting'>> {
  meeting?: RootStore['meeting'];
  className?: string;
}
const SupportMessage: React.FC<Props> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { meeting, className } = props;
    const { formatMessage } = useIntl();

    const supportByMsgId = useMemo(() => {
      if (meeting?.codeEditorEnabled) return 'SUPPORT_BY_QA_ZEN';
      return 'POWERED_BY';
    }, [meeting?.codeEditorEnabled]);

    return (
      <div className={classNames(styles.supportMessage, className)}>
        {formatMessage({ id: supportByMsgId })}
        <BetaTag />
      </div>
    );
  })
);

export default SupportMessage;
